import { FarmVote } from './';

export default {
  path: 'vote',
  childRoutes: [
    { path: 'farm', component: FarmVote, isIndex: false },
  ]
};